// src/utils/userUtils.js
export function processUser(rawUserData) {
  if (!rawUserData) return null;

  return {
    uid: rawUserData.uid || null,
    username: rawUserData.userDisplayName || "null-error",
    rank: rawUserData.userRank ?? 0,
    money: rawUserData.userMoney ?? 0,
    xp: rawUserData.userXP ?? 0,
    portfolioValue: rawUserData.userPortfolioValue ?? 0,
    jackpotTicketsOwned: rawUserData.userJackpotTicketsOwned ?? 0,
    netWorth:
      (rawUserData.userMoney ?? 0) + (rawUserData.portfolioValue ?? 0),
  };
}
